/*
- true: 本日/明日/明後日
- false: その他
*/

type DeadlineStatus = {
  isHighlight: boolean;
  text: string;
};

export const getDeadlineStatus = (deadline: Date): DeadlineStatus => {
  const now = new Date();
  const today = new Date(now.getFullYear(), now.getMonth(), now.getDate());
  const deadlineDate = new Date(
    deadline.getFullYear(),
    deadline.getMonth(),
    deadline.getDate(),
  );

  const days = ['本日', '明日', '明後日'];

  for (const [i, day] of days.entries()) {
    const compareDate = new Date(today);
    compareDate.setDate(today.getDate() + i);

    if (deadlineDate.toDateString() === compareDate.toDateString()) {
      return {isHighlight: true, text: day};
    }
  }

  return {isHighlight: false, text: ''};
};
